import React from 'react';
import PropTypes from 'prop-types';

const Divider = ({
  label,
  textColor,
  lineColor,
  style,
}) => (
  <div style={style} className="divider-line-container">
    <div style={{ backgroundColor: lineColor }} className="divider-line" />
    {label && <p style={{ color: textColor }}>{label}</p>}
    <div style={{ backgroundColor: lineColor }} className="divider-line" />
  </div>
);

Divider.propTypes = {
  label: PropTypes.string,
  textColor: PropTypes.string,
  lineColor: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.string),
};

Divider.defaultProps = {
  textColor: 'black',
  lineColor: '#888787',
  style: {},
  label: '',
};

export default Divider;
